import { useState } from 'react';

const faqs = [
  {
    question: '龙禁漫提供哪些类型的漫画？',
    answer: '龙禁漫涵盖热血、恋爱、悬疑、奇幻、搞笑、科幻、恐怖、武侠、日常等九大漫画分类。无论你喜欢战斗冒险、甜蜜爱情还是烧脑推理，都能在龙禁漫找到心仪的作品。平台持续引入新作品，不断丰富漫画资源库。',
  },
  {
    question: '龙禁漫的漫画资源是否正版？',
    answer: '是的，龙禁漫与多家国内外知名漫画出版社和作者建立了正版授权合作关系，平台所有漫画内容均为正版授权。我们致力于为读者提供高质量的阅读体验，同时保护创作者的合法权益，推动漫画产业的健康发展。',
  },
  {
    question: '如何在龙禁漫上找到想看的漫画？',
    answer: '您可以通过以下方式发现感兴趣的内容：首页的热门推荐为您精选最受欢迎的漫画；分类浏览功能帮助您按题材筛选；此外，每部漫画都有详细的标签和简介，您还可以通过搜索功能精准定位想看的作品。',
  },
  {
    question: '龙禁漫是否支持离线阅读？',
    answer: '龙禁漫支持漫画下载功能。您可以将喜欢的漫画章节下载到本地设备，在没有网络的情况下也能畅快阅读。下载的内容会保存在您的设备中，方便随时随地享受漫画乐趣。',
  },
  {
    question: '龙禁漫的更新频率如何？',
    answer: '龙禁漫平台上的热门连载漫画通常保持稳定的更新频率，热门作品一般每周更新一到两次，部分超高人气作品甚至保持每日更新。我们会第一时间同步正版授权的最新章节，让读者不错过任何精彩内容。',
  },
  {
    question: '龙禁漫是否需要付费？',
    answer: '龙禁漫提供大量免费漫画供读者阅读。同时，部分优质正版作品采用"免费试读+付费解锁"的模式，让读者可以先体验再决定是否购买。我们致力于在保障创作者权益的同时，为读者提供最优质的阅读服务。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100" aria-labelledby="faq-section-title">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 id="faq-section-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2">关于龙禁漫，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-left hover:bg-background-100/50 transition-colors duration-200"
                aria-expanded={openIndex === index}
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 md:px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}